import { Component, inject, OnInit } from "@angular/core";
import { ActivatedRoute, Router, RouterOutlet } from "@angular/router";
import { environment } from "../environments/environment";
import { AuthService } from "./services/auth/auth.service";
import { BnNgIdleService } from "bn-ng-idle";
import { DevtoolsGuardService } from "./services/devtools/devtools-guard.service";
import { distinctUntilChanged, filter } from "rxjs";

@Component({
  selector: "app-root",
  template: ` <router-outlet /> `,
  imports: [RouterOutlet]
})
export class AppComponent implements OnInit {
  authService = inject(AuthService);
  bnIdle = inject(BnNgIdleService);
  router = inject(Router);
  devtoolsGuard = inject(DevtoolsGuardService);

  ngOnInit(): void {
    this.devtoolsGuard.startMonitoring();
    this.devtoolsGuard.devtoolsOpen$
      .pipe(
        distinctUntilChanged(),
        filter((isOpen) => environment.production && isOpen)
      )
      .subscribe(() => {
        this.authService.logout();

        if (this.router.url !== "/login") {
          this.router.navigate(["login"], { replaceUrl: true });
        }
      });

    if (environment.enableIdleWatch) {
      this.bnIdle.startWatching(180).subscribe((res) => {
        if (res) {
          this.authService.logout();
          this.router.navigate(["login"]);
        }
      });
    }
  }
}
